<template>
    <div class="con">
        <div class="banner" v-if="select===0">
            <img src="../assets/zy/nbanner.png" alt="">
        </div>
        <div class="banner" v-else>
            <img src="../assets/zy/nbanner2.png" alt="">
        </div>
        <div class="main">
<!--            <div class="navList wow fadeInUp">-->
<!--                <div class="item " v-for="(item,index) in $t('news').navList" :key="index" :class="{active:select===index}" @click="change(index)">-->
<!--                    {{item}}-->
<!--                </div>-->
<!--            </div>-->
            <transition name="fade">
                <div class="content" v-if="select===0">
                    <div class="lList wow fadeInLeft">
                        <p class="title">{{$t('news').navList[0]}}</p>
<!--                        <div class="list">-->
<!--                            <p v-for="(item,index) in list" :key="index" @click="getNews(item.id)">{{item.classname}}</p>-->
<!--                        </div>-->
                        <swiper :options="swiperOptionTopa" class="gallery-top" ref="swiperTopa">
                            <swiper-slide class="item" v-for="(item,index) in list" :key="index">
                                <div class="one" @click="getNews(item.id)">
                                    {{item.classname}}
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div>
                        </swiper>
<!--                        <div class="page wow fadeInUp">-->
<!--                            <el-pagination-->
<!--                                    layout="prev, pager, next"-->
<!--                                    :pager-count="5"-->
<!--                                    @current-change="handleCurrentChange"-->
<!--                                    :page-count="totalPage">-->
<!--                            </el-pagination>-->
<!--                        </div>-->
                        <div class="search">
                            <input type="text" placeholder="Search" v-model="keywords">
                            <i class="iconfont icon-sousuo" @click="getSearch"></i>
                        </div>
                    </div>
                    <div class="mInfo wow fadeInRight">
                        <div class="allItems">
                            <div class="item" v-for="(item,index) in nList" :key="index"  @click="gotoPdf(item.pdf2)">
                                <div class="one">
                                    <p style="opacity: 0">0{{index+1}}</p>
                                    <p>{{item.title}}</p>
                                    <p style="display: none">{{item.posttime | formatDate}}</p>
                                    <p v-html="item.description"></p>
                                    <div class="dots">
                                        <span></span><span></span><span></span>
                                    </div>
                                    <div class="img">
                                        <img :src="`https://dhkbearing.net/${item.picurl}`" alt="">
                                    </div>
                                    <div class="btns">
                                       {{$t('news').btn}}
                                        <i class="el-icon-caret-right"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <transition name="fade">
                <div  class="company" v-if="select===1">
                <div class="nCommend wow" @click="gotoInfo(tInfo.id)">
                   <div class="l">
                       <img :src="`https://dhkbearing.net/${tInfo.timg}`" alt="">
                   </div>
                    <div class="r">
                      <p>{{tInfo.title}}</p>
                        <p>
                           {{tInfo.description}}
                        </p>
                        <p>
                            <i class="iconfont icon-shijian"></i>
                            <span>{{tInfo.posttime | formatDate}}</span>
                            <i class="iconfont icon-jiantou"></i>
                        </p>
                    </div>
                </div>
                    <div class="allImgs wow">
                        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                            <swiper-slide class="item" v-for="(item,index) in cList" :key="index">
                                <div  class="one" @click="gotoInfo(item.id)">
                                    <img :src="`https://dhkbearing.net/${item.picurl}`" alt="">
                                </div>
                                <div class="two" @click="gotoInfo(item.id)">
                                    <p>{{item.title}}</p>
                                    <p>{{item.description}}</p>
                                    <div>
                            <span>
                                <i class="iconfont icon-shijian"></i>
                                    {{item.posttime | formatDate}}
                            </span>
                                        <span>
                                <i class="iconfont icon-jiantou"></i>
                            </span>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <swiper :options="swiperOptionTop2" class="gallery-top gallery-top2" ref="swiperTop2">
                            <swiper-slide class="item" v-for="(item,index) in cList" :key="index">
                                <div  class="one" @click="gotoInfo(item.id)">
                                    <img :src="`https://dhkbearing.net/${item.picurl}`" alt="">
                                </div>
                                <div class="two" @click="gotoInfo(item.id)">
                                    <p>{{item.title}}</p>
                                    <p>{{item.description}}</p>
                                    <div>
                            <span>
                                <i class="iconfont icon-shijian"></i>
                                    {{item.posttime | formatDate}}
                            </span>
                                        <span>
                                <i class="iconfont icon-jiantou"></i>
                            </span>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </div>
                </div>
            </transition>

        </div>
        <foot-Component class="wow fadeIn"></foot-Component>
    </div>
</template>

<script>
    import footComponent from '../components/foot'
    import Scrollbar from 'smooth-scrollbar'
    import {getSearch,getClass,PageModel,getProductsUrl} from '../util/lang'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: 'about',
        data(){
            return{
                keywords:'',
                totalPage:0,
                id:'',
                navList:[
                    "企业内刊",
                    "公司新闻"
                ],
                swiperOptionTopa: {
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        renderBullet(index, className) {
                            return `<span class="${className} swiper-pagination-bullet-custom"></span>`
                        }
                    },
                    notNextTick: true,
                    centeredSlides : true,
                    // slideToClickedSlide: true,
                    slidesPerView:1,//一行显示3个
                    slidesPerColumn: 5,//显示2行
                    speed:1000,
                    init:false,
                    loop:false,
                    setWrapperSize :true,
                    autoplay: false,
                    navigation: {
                        prevEl: '.allImgs .btn.prev',
                        nextEl: '.allImgs .btn.next',
                    }
                },
                swiperOptionTop: {
                    slidesPerView:3,//一行显示3个
                    speed:1000,
                    init:true,
                    slidesPerGroup : 3,
                    loop:false,
                    spaceBetween :50,
                    setWrapperSize :true,
                    autoplay: false,
                    pagination: {
                        el: '.allImgs .swiper-pagination',
                        clickable: true
                    }
                },
                swiperOptionTop2: {
                    slidesPerView:1,//一行显示3个
                    speed:1000,
                    init:true,
                    loop:false,
                    setWrapperSize :true,
                    autoplay: false,
                    pagination: {
                        el: '.allImgs .swiper-pagination',
                        clickable: true
                    }
                },
                select:1,
                list:[],
                nList:[],
                tInfo:{},
                cList:[]
            }
        },
        filters: {
            formatDate: function (value) {
                value=parseInt(value)*1000
                let date = new Date(value);
                let y = date.getFullYear();
                let MM = date.getMonth() + 1;
                MM = MM < 10 ? ('0' + MM) : MM;
                let d = date.getDate();
                d = d < 10 ? ('0' + d) : d;
                let h = date.getHours();
                h = h < 10 ? ('0' + h) : h;
                let m = date.getMinutes();
                m = m < 10 ? ('0' + m) : m;
                let s = date.getSeconds();
                s = s < 10 ? ('0' + s) : s;
                return y + '-' + MM + '-' + d + ' ' ;
            }
        },
        components:{footComponent,   swiper, swiperSlide },
        mounted() {
            Scrollbar.initAll(document.getElementById("scroller-wrapper"));
            this.scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            this.scrollbar.scrollTo(0,1)
            this.scrollbar.addListener((status) => {
                window.pageYOffset=this.scrollbar.scrollTop
            });
            this.$nextTick(()=>{
                if(this.$i18n.locale==='en'){
                    this.getNav('116')
                    this.getNews('117')
                    this.getCom('119')
                }else{
                    this.getNav('16')
                    this.getNews('17')
                    this.getCom('19')
                }
                if(window.location.search.replace('?', '').split('=')[1]!==undefined){
                    this.setIndex(parseInt(this.getNid()))
                    // this.getNews(13+parseInt(this.getNid()))
                }else{
                    // this.getNews('13')
                }
            })
        },
        methods:{
            gotoPdf(n){
                window.open(`http://www.dhkbearing.com/${n}`,'_blank')
            },
            getSearch(){
                const url = `${getSearch('106',this.keywords)}`
                this.$axios.get(url).then(res => {
                  this.nList=res.data.data
                    this.keywords=''
                })
            },
            getNav(id){
                const url = `${getClass(id)}`
                this.$axios.get(url).then(res => {
                    this.list=res.data.data
                    setTimeout(()=>{
                        this.$refs.swiperTopa.swiper.init()
                    },100)
                })
            },
            handleCurrentChange(val) {
                if(val<=this.totalPage){
                    this.$nextTick(()=>{
                        const url = `${PageModel('PageModel',val++,4,this.id)}`
                        this.$axios.get(url).then(res => {
                            this.nList=res.data.data
                        })
                    })
                }else{
                    this.$notify({
                        title: 'Prompt',
                        message: 'Already Loaded',
                        offset: 100
                    });
                }
            },
            setIndex(n){
                this.select=n
            },
            change(n){
                const link=`/news.html?index=${n}`
                window.open(link,'_self')
            },
            getNid () {
                return window.location.search.replace('?', '').split('=')[1].split('?')[0]
            },
            getNews(id){
                this.id=id
                const url = `${PageModel('PageModel',1,4,id)}`
                this.$axios.get(url).then(res => {
                    this.nList=res.data.data
                    console.log(res.data)
                    this.totalPage=res.data.totalPage
                    // setTimeout(()=>{
                    //     this.$refs.swiperTop.swiper.init()
                    // },100)
                })
            },
            getCom(id){
                let list=[]
                const url = `${getProductsUrl(id)}`
                this.$axios.get(url).then(res => {
                    this.cList=res.data.data
                    res.data.data.map((item)=>{
                        if(item.flag=="h"){
                           this.tInfo=item
                        }
                    })
                    // this.tInfo=list[0]
                })
            },
            gotoInfo(id){
                if(this.select===0){
               const link=`/newsInfo.html?id=${id}`
                window.open(link,'_blank')
                }else{
                     const link=`/newsInfo2.html?id=${id}`
                window.open(link,'_blank')
                }

            },
        }
    }
</script>

<style lang="scss" scoped>
    .con{
        width:100%;
        animation: run5 1s linear forwards;
        position: relative;
        @keyframes run5 {
            from{
                opacity: 0;
            }
            to{
                opacity: 1;
            }
        }
        .banner{
            width:100%;
            position: relative;
            overflow: hidden;
            img{
                display: block;
                width:100%;
                object-fit: cover;
                animation: sbig 2s linear forwards;
            }
            @keyframes sbig {
                from{
                    transform: scale(1);
                    filter: blur(5px);
                }
                to{
                    transform: scale(1.05);
                    filter: blur(0);
                }
            }
        }
        .main{
            width:100%;
            margin: 0 auto;
            .navList{
                width:100%;
                display: flex;
                flex-direction: row;
                justify-content: center;
                box-shadow:0px 9px 42px 9px rgba(0, 0, 0, 0.03);
                .item{
                    -webkit-tap-highlight-color: rgba(0,0,0,0);
                    font-weight: lighter;
                    cursor: pointer;
                    transition: 0.3s;
                    position: relative;
                    padding:5px 50px;
                    color:#333333;
                    font-size: 14px;
                    height: 50px;
                    line-height: 50px;
                    display: block;
                    z-index: 1;
                    font-family: "SOURCEHANSANSCN-LIGHT.OTF";
                    &::before{
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 100%;
                        background-color:#FECE4A;
                        transform-origin: 100%;
                        -webkit-transform-origin: 100%;
                        -webkit-transition: -webkit-transform .5s cubic-bezier(.4,0,.2,1);
                        transition: transform .5s cubic-bezier(.4,0,.2,1);
                        transform: scaleX(0);
                        -webkit-transform: scaleX(0);
                        visibility: hidden\9;
                        z-index: -1;
                    }
                    &:hover{
                        color:white;
                    }
                    &:hover::before{
                        transform: scaleX(1);
                        -webkit-transform: scaleX(1);
                        -moz-transform: scaleX(1);
                        transform-origin: 0;
                        -webkit-transform-origin: 0;
                        visibility: visible\9;
                    }
                }
                .active{
                    color:white;
                }
                .active::before{
                    transform: scaleX(1);
                    -webkit-transform: scaleX(1);
                    -moz-transform: scaleX(1);
                    transform-origin: 0;
                    -webkit-transform-origin: 0;
                    visibility: visible\9;
                }
            }
            .content{
                width:1440px;
                margin: 0 auto;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 80px 0;
                .lList{
                    width:20%;
                    position: relative;
                    .title{
                        color:#333333;
                        font-family: "SourceHanSansSC-Medium";
                        font-size: 20px;
                        border-bottom: 1px solid #DCDCDC;
                        padding: 30px 0;
                    }
                    .list{
                        width:100%;
                        margin: 30px auto;
                       p{
                           color:#333333;
                           font-family: "SourceHanSansSC-Normal";
                           margin-top: 15px;
                           cursor: pointer;
                           transition: all 600ms;
                            &:hover{
                                color:#FECD4A;
                            }
                       }
                    }
                    .gallery-top{
                        margin: 30px auto;
                        width:100%;
                      padding-bottom: 40px;
                        .item{
                            .one{
                                color:#333333;
                                font-family: "SourceHanSansSC-Normal";
                                margin-top: 15px;
                                cursor: pointer;
                                transition: all 600ms;
                                &:hover{
                                    color:#FECD4A;
                                }
                            }
                        }
                    }
                    .page{
                        width:100%;
                        margin-left: -10px;
                    }
                    .search{
                        width:100%;
                        position: relative;
                        margin: 30px auto;
                        input{
                            width:100%;
                            background-color: #F3F3F3;
                            height:35px;
                            border: none;
                            text-indent: 10px;
                        }
                        i{
                            position: absolute;
                            right:10px;
                            top:10px;
                            color:black;
                            cursor: pointer;
                        }
                    }
                }
                .mInfo{
                    width:75%;
                    .allItems{
                        width:100%;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                        justify-content: center;
                        .item{
                            width:100%;
                            margin-top: 40px;
                            .one{
                                cursor: pointer;
                                p:nth-child(1), p:nth-child(2){
                                    color:#919191;
                                    font-family: "Microsoft YaHei UI";
                                    font-size: 18px;
                                    margin-top: 8px;
                                    transition: all  600ms;
                                }
                                p:nth-child(2){
                                    color:#585858;
                                }
                                p:nth-child(3){
                                    font-size: 12px;
                                    font-family: "Microsoft YaHei UI";
                                    color:#A6A6A6;
                                    margin-top: 8px;
                                }
                                p:nth-child(4){
                                    color:#919191;
                                    font-size: 13px;
                                    line-height: 24px;
                                    font-family: "Microsoft YaHei UI";
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 2;
                                    overflow: hidden;
                                    height:48px;
                                    margin: 8px auto;
                                }
                                .dots{
                                    width:100%;
                                    display: flex;
                                    flex-direction: row;
                                    span{
                                        display: inline-block;
                                        height:8px;
                                        width:8px;
                                        border-radius: 50%;
                                        background-color: #919191;
                                    }
                                    span:not(:first-child){
                                        margin-left: 5px;
                                    }
                                }
                                .img{
                                    width:100%;
                                    overflow: hidden;
                                    margin: 20px 0;
                                    img{
                                        width:100%;
                                        display: block;
                                        object-fit: cover;
                                        transition: all  600ms;
                                    }
                                }
                                .btns{
                                    // border: 1px solid #F6C02E;
                                    text-align: center;
                                    padding: 10px  10px;
                                    border-radius: 5px;
                                    font-size: 14px;
                                    transition: all 600ms;
                                    display: inline-block;
                                }
                                &:hover{
                                    p:nth-child(1), p:nth-child(2){
                                        color:#FECE4A;
                                    }
                                    .img{
                                        img{
                                            transform: scale(1.2);
                                        }
                                    }
                                    .btns{
                                        border-color: transparent;
                                        color:#F6C02E;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .company{
                width:1440px;
                margin: 60px auto;
                .nCommend{
                    width:100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    cursor: pointer;
                    animation:polygon 1s  forwards linear  ;
                    .l{
                        width:66%;
                        cursor: pointer;
                        overflow: hidden;
                        img{
                            width:100%;
                            display: inline-block;
                            object-fit: cover;
                            transition: all 600ms;
                        }
                    }
                    .r{
                        width:30%;
                        p:nth-child(1){
                            color:#585858;
                            font-size: 18px;
                            font-family: "Microsoft YaHei UI";
                            margin-top: 30px;
                            display: flex;
                            flex-direction: row;
                            transition: all 600ms;
                            font-weight: bolder;
                            &::before{
                                content:'';
                                display: inline-block;
                                width:2px;
                                height:30px;
                                background:rgba(254,206,74,1);
                                margin-right: 15px;
                            }
                        }
                        p:nth-child(2){
                            color:#919191;
                            font-size: 13px;
                            line-height: 25px;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 4;
                            overflow: hidden;
                            height:100px;
                            margin: 20px auto;
                            margin-left: 20px;
                        }
                        p:nth-child(3){
                            width:100%;
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            color:#A6A6A6;
                            position: relative;
                            margin-top: 30px;
                            i{
                                font-size: 20px;
                            }
                            span{
                                display: inline-block;
                                margin-left: 30px;
                                font-family: "SOURCEHANSANSCN-LIGHT";
                            }
                            .icon-jiantou{
                               position: absolute;
                                right:0;
                                top:0;
                                transition: all 600ms;
                            }
                        }
                    }
                    &:hover{
                        .l{
                            img{
                                transform: scale(1.2);
                            }
                        }
                        .r{
                            p:nth-child(1){
                                color:#FECE4A;
                            }
                            p:nth-child(3){
                                .icon-jiantou{
                                    color:#FECE4A;
                                }
                            }
                        }
                    }
                }
                .allImgs{
                    width:100%;
                    margin: 0 auto;
                    position: relative;
                    padding: 80px 0;
                    animation:polygon 1s  forwards linear  ;
                    .gallery-top{
                        width:100%;
                        .item{
                            cursor: pointer;
                            .one{
                                width:100%;
                                overflow: hidden;
                                img{
                                    width:100%;
                                    object-fit: cover;
                                    height:245px;
                                    display: block;
                                    transition: all 600ms;
                                }
                            }
                            .two{
                                width:90%;
                                margin: 0 auto;
                                p:nth-child(1){
                                    color:#585858;
                                    font-size: 18px;
                                    font-family: "Microsoft YaHei UI";
                                    margin-top: 30px;
                                    display: flex;
                                    flex-direction: row;
                                    transition: all 600ms;
                                    font-weight: bolder;
                                    &::before{
                                        content:'';
                                        display: inline-block;
                                        width:2px;
                                        height:30px;
                                        background:rgba(254,206,74,1);
                                        margin-right: 15px;
                                    }
                                }
                                p:nth-child(2){
                                    color:#919191;
                                    font-family: "SOURCEHANSANSCN-LIGHT";
                                    font-size: 13px;
                                    line-height: 24px;
                                    margin-bottom: 10px;
                                    display: -webkit-box;
                                    -webkit-box-orient: vertical;
                                    -webkit-line-clamp: 3;
                                    overflow: hidden;
                                    height:48px;
                                    margin-top: 10px;
                                    width:80%;
                                    margin-left: 18px;
                                }
                                div{
                                    width:100%;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    span:nth-child(1){
                                        display: flex;
                                        flex-direction: row;
                                        color:#A6A6A6;
                                        font-size: 12px;
                                        align-items: center;
                                        i{
                                            color:#A6A6A6;
                                            margin-right: 10px;
                                        }
                                    }
                                    span:nth-child(2){
                                        i{
                                            color:#A6A6A6;
                                            font-size: 20px;
                                            transition: all 600ms;
                                        }
                                    }
                                }
                            }
                            &:hover{
                                .one{
                                    img{
                                        transform: scale(1.05);
                                    }
                                }
                                .two{
                                    p:nth-child(1){
                                        color:#FECE4A;
                                    }
                                    div{
                                        span:nth-child(2){
                                            i{
                                                color:#FECE4A;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .gallery-top2{
                        display: none;
                    }
                }
            }
        }
        .foot{
            animation-name: polygon;
            animation-duration: 2s;
        }
        @keyframes transition1 {
            0% {
                transform: translate(-300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes transition2 {
            0% {
                transform: translate(300px,-300px);
                opacity: 0;
            }
            100% {
                transform: translate(0,0);
                opacity: 1;
            }
        }
        @keyframes polygon {
            0% {
                clip-path: polygon(0 0,0 100%,0 100%,0 0);
                opacity: 0;
            }
            100% {
                clip-path: polygon(0 0,0 100%,100% 100%,100% 0);
                opacity: 1;
            }
        }
        @media screen and (max-width: 1440px){
            .main{
              width:90%;
                .content,.company{
                    width:100%;
                }
            }
        }
        @media screen and (max-width: 1000px){
            .banner{
                img{
                    height:500px;
                }
            }
            .main{
                width:100%;
                .navList{
                    .item{
                        padding: 10px 0;
                        width:50%;
                        text-align: center;
                    }
                }
                .content{
                    width:90%;
                    flex-direction: column;
                    .lList{
                        width:100%;
                    }
                    .mInfo{
                        width:100%;
                        .allItems{
                            flex-direction: column;
                            .item{
                                width:100%;
                                margin-top: 10px;
                            }
                        }
                    }
                }
                .company{
                    width:90%;
                    .nCommend{
                        flex-direction: column;
                        .l,.r{
                            width:100%;
                            margin-left: 0;
                        }
                    }
                    .allImgs{
                        .gallery-top{
                            display: none;
                        }
                        .gallery-top2{
                            display: block;
                        }
                    }
                }
            }
        }
    }
</style>
<style scoped>
    .lList .swiper-pagination {
        bottom: 0;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
    }
    .lList >>>.swiper-pagination-bullet-active{
        background-color: #FFBA00 !important;
    }
</style>
<style scoped>
    .allImgs .swiper-pagination {
        bottom: 0;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet {
        font-size: 16px;
        font-family: "SOURCEHANSANSCN-BOLD";
        background-color: rgba(0,0,0,.2);
        margin-top: 20px;
        width:48px;
        height:1px;
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 50px;
        margin-left: 30px;
        text-align: center;
        position: relative;
        color:transparent;
        transition: all 600ms;
        opacity: 1;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .allImgs .swiper-pagination>>>.swiper-pagination-bullet-active{
        background-color: #FECE4A;
    }
</style>
